"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialPlanner = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var performance_1 = require("../../model/performance");
var service_1 = require("../../../library/base/service");
var FinancialPlanner = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(FinancialPlanner, _super);
    function FinancialPlanner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '我的理财师';
        _this.code = '101030';
        _this.desc = '我的理财师';
        _this.requestParams = new performance_1.FinancialPlannerRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return FinancialPlanner;
}(service_1.BaseService));
exports.FinancialPlanner = FinancialPlanner;
//# sourceMappingURL=financialPlanner.js.map